import { gql } from '@apollo/client/core'

export const CANCELLATIONS_EXPORT = gql`
  mutation cancelationsExportSend(
    $startingDate: ISO8601DateTime!
    $endingDate: ISO8601DateTime!
  ) {
    cancelationsExportSend(
      startingDate: $startingDate
      endingDate: $endingDate
    ) {
      result {
        status
        message
      }
    }
  }
`

export interface CancellationsExportVariables {
  startingDate: string,
  endingDate: string
}

export interface CancellationsExportResult {
  result: {
    message: string,
    status: string
  }
}
